import customerApi from './customer-api-client';

async function getFileUploadInfo() {
    let res = await customerApi.file.createFormDataPolicy({
        "minSize": 1,
        "maxSize": 314572800,
        "expiry": 0,
        "fileCount": 1
    });

    if (res.status == 200) {
        let dat = res.data;
        let file = dat.files[0]

        return {
            action: dat.host,
            OSSAccessKeyId: dat.accessId,
            callback: dat.callback,
            key: file.key,
            policy: file.policy,
            signature: file.signature,
        }
    } else {
        throw new Error("获取上传信息失败")
    }
}

function getError(action, xhr) {
    var msg = void 0;
    if (xhr.response) {
        msg = '' + (xhr.response.error || xhr.response);
    } else if (xhr.responseText) {
        msg = '' + xhr.responseText;
    } else {
        msg = 'fail to post ' + action + ' ' + xhr.status;
    }

    var err = new Error(msg);
    err.status = xhr.status;
    err.method = 'post';
    err.url = action;
    return err;
}

function getBody(xhr) {
    var text = xhr.responseText || xhr.response;
    if (!text) {
        return text;
    }

    try {
        return JSON.parse(text);
    } catch (e) {
        return text;
    }
}

export default {
    uploadFile(file) {
        if (typeof XMLHttpRequest === "undefined")
            throw new Error("XMLHttpRequest is undefined")

        return new Promise((resolve, reject) => {
            getFileUploadInfo().then(function (updInfo) {
                try {
                    var xhr = new XMLHttpRequest();
                    var action = updInfo.action                    
                    var formData = new FormData();
                    formData.append('key', updInfo.key);
                    formData.append('policy', updInfo.policy);
                    formData.append('OSSAccessKeyId', updInfo.OSSAccessKeyId);
                    formData.append('success_action_status', "200");
                    formData.append('callback', updInfo.callback);
                    formData.append('signature', updInfo.signature);
                    formData.append("file", file, file.name);

                    xhr.onerror = function error(e) {
                        reject(e)
                    };

                    xhr.onload = function onload() {
                        if (xhr.status < 200 || xhr.status >= 300) {
                            reject(getError(action, xhr));
                        }
                        else {
                            resolve(getBody(xhr));
                        }
                    };

                    xhr.open("post", action, true);
                    xhr.send(formData);
                }
                catch (e) {
                    reject(e)
                }
            }, function (error) {
                reject(error)
            })
        })
    }
}
